import * as React from "react";

// @ts-ignore
import icon from "./bottomArrow.svg";

interface IProps {
  className?: string;
}

export const BottomArrow : React.SFC < IProps > = (props : IProps) => {
  return <img src={icon} className={props.className}/>;
};



// WEBPACK FOOTER //
// ./src/components/Icons/BottomArrow/BottomArrow.tsx